<p-floatLabel>
  <p-select #informationSourceStateDropdown
    id="informationSourceStateDropdown"
    name="informationSourceStateDropdown"
    [options]="informationSourceStates"
    [(ngModel)]="informationSourceState"
    [showClear]="!isRequired"
    [checkmark]="true"
    styleClass="w-100"
    (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="informationSourceStateDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>
